type Properties = {
    viewCoachPicker: () => any,
    isHidden: boolean
};

const ViewCoachPickerButton = (props: Properties) => {
    if (props.isHidden) {
        return <></>;
    }

    return (
        <div className="page-coach" data-testid="view-coach-picker-button">
            <p><button className="primary" onClick={props.viewCoachPicker}>Bitte einen Coach wählen!</button></p>
        </div>
    );
};

export default ViewCoachPickerButton;